import { MED_IMG_PRE_PATH, GROUP_IMG_PRE_PATH, GOV_IMG_PRE_PATH, LINK_PRE_PATH } from './index';

export const headBg = MED_IMG_PRE_PATH + 'm/ba540d24970a2846ef917e620be0ff22fa8ffcd08762b9a6d68cc8c35fb800d7.jpg';
export const headBgM = MED_IMG_PRE_PATH + 'm/5f158cf49ad11b1d2ee24eec53a878701dfd1d308c3c76013ea31ff2db25bb71.jpg';
export const frameSrc = MED_IMG_PRE_PATH + 'm/df937162b86bd660a122f74edccad4dbff295fa2348bd66641c47937f29a1f0b.jpg';
export const frameSrcM = MED_IMG_PRE_PATH + 'm/61fc212a5f73a26e86b34bae7e9820e958fa026d09434a270c572225e60fc18e.jpg';

export const challenge = [
  {
    icon: MED_IMG_PRE_PATH + 'm/ea791b742ef858cffe22269290d915ef77953a0081df3787062f5290eeedd444.png',
    title: '区域医疗资源分布不均衡',
    desc: '医疗资源分布不均衡，欠发达地区医疗资源不足，亟需促进医院分级协作，提高医疗水平',
  },
  {
    icon: MED_IMG_PRE_PATH + 'm/55c143ac2061897888707a9480170c9ff81a86297caac5bf400804a79acc8e86.png',
    title: '跨医院、跨科室、跨部门协同难',
    desc: '各医院信息系统相互独立，医疗信息无法互联互通，科室之间信息孤岛及数据不同步，难以高效协作',
  },
  {
    icon: MED_IMG_PRE_PATH + 'm/24a6a395086d82b7b75cd388240b7e61407536e371dd4f117fed76759f3468e6.png',
    title: '基层医疗机构基础设施薄弱',
    desc: '基层医疗机构建设不足，基层医疗单位的诊疗水平及救治服务效率较低，医疗服务覆盖面有限',
  },
  {
    icon: MED_IMG_PRE_PATH + 'm/0ac9a483a59b03ab8ebb711051c4253be6889b4050e991e4ada3d886281f12be.png',
    title: '基层医疗人才培养难',
    desc: '基层医疗人员分布不均，缺少稳定的人才培训体系，医院间难以开展临床教学、医疗专科交流等研讨',
  },
];
export const frame = [
  {
    title: '高效视频协同',
    icon: GOV_IMG_PRE_PATH + 'pc/bfb3d4b4b4b6729fa3595f0fc4c1ebb598a04a7d88399377c7eebc230cd20d0f.png',
  },
  {
    title: '共享优质医疗',
    icon: MED_IMG_PRE_PATH + 'm/f8e5d92cda26f961e75272f1af74933fbc0ba02e4a1a54bf38514cef36b93ff5.png',
  },
  {
    title: '扩大医疗覆盖',
    icon: MED_IMG_PRE_PATH + 'm/c1f7e55d378c9627a705e7db1c71598e9748138a2ecbe91791d3ceec9313b13d.png',
  },
  {
    title: '助力人才培养',
    icon: MED_IMG_PRE_PATH + 'm/c9d31c599800d26768ca94dfa3e8c1a52817b1262601f912a76b0e9e3a10f0dd.png',
  },
];
export const advantage = [
  {
    icon: MED_IMG_PRE_PATH + 'm/749565fbd4f73a338802b51b1d5558f74226b098212cfe9519fa20801aee2837.png',
    title: '高兼容利旧',
    desc: '有效兼容现有音视频远程会诊系统，保护前期投资，扩展业务应用范围，医疗方案部署简单，使用便捷高效，医疗机构运维成本低',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/68979ad392e91c378cf24b24c95fffd44bfc3d080c65373c0a037be1314f36c8.png',
    title: '超融合应用',
    desc: '统一的媒体接入能力，可将医院科室、病房、乡镇村卫生机构、养老机构全接入，实现远程会诊、监控、直播、录播、数据、语音等应用',
  },
  {
    icon: MED_IMG_PRE_PATH + 'm/7ea5a8941cc1eda63537c9577c2a931742522ce4c1654e5be92f3e04b41942f4.png',
    title: '大规模并发',
    desc: '具有超大规模接入能力，7年不间断运营，打造了超大规模的云视频服务平台，满足跨科室、跨医院大并发云视频需求',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/faf1f6749cd9696565108b7f79fbfdd524c6bfce90020c55138f9eaf87719206.png',
    title: '全场景覆盖',
    desc: '覆盖各类型医院的大中小会议室、桌面、移动端、无人机等各类型终端，可灵活接入医疗内外网、医疗专网、互联网、4G/5G等多网络环境',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/b0af140cad95de7891bdab6214a51adc0bd6ffcf8da3093cde0e8f83cf9abcca.png',
    title: '强稳定可靠',
    desc: '运营级集群架构，MCU资源池，多活热备，服务器宕机可在3秒左右实现自动迁移，有效保障远程医疗业务不中断',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/72abb4a6fb3e84800a01164b1497efa20ae197c93d1213928156bb947035a3b0.png',
    title: '开放式集成',
    desc: '全面开放API/SDK，深度融合医疗服务场景，打造综合性远程医疗平台，打通卫生信息平台等多业务系统',
  },
];
export const scene = [
  {
    title: '远程会诊',
    desc: '结合影像/B超/心电等医疗设备远程诊断，将优质医疗资源下沉至基层',
    pcUrl: MED_IMG_PRE_PATH + 'm/65c73864b13868d6989ef0d400c08039e1403047e10e0019ff4a28a0765225f3.jpg',
  },
  {
    title: '示教培训',
    desc: '通过“互联网+医疗”方式呈现手术示教过程，突破传统手术教学培训弊端',
    pcUrl: MED_IMG_PRE_PATH + 'm/2898c869de6b9b8ad78cfceedb882d1aa98c8d3a6c42d698530bfd46a238d97b.jpg',
  },
  {
    title: '远程查房',
    desc: '远程专家可灵活高效地进行远程例行查房，了解患者病情及康复情况',
    pcUrl: MED_IMG_PRE_PATH + 'm/54d9160848f16ae1eb8dd8e716328338cca3460c34cf6ca23d4c7127f0fc3d03.jpg',
  },
  {
    title: '急救救护',
    desc: '快速且最大限度还原急救实况，医疗专家及时参与远程急救指导工作',
    pcUrl: MED_IMG_PRE_PATH + 'm/1dff28602388f7ce9a940798997b5539ad7a80f6819b151af9eee54b44bca5ec.jpg',
  },
  {
    title: '内外协同',
    desc: '实时启动院内外视频会议，加速跨科室、跨医院的传达效率',
    pcUrl: MED_IMG_PRE_PATH + 'm/1dd280a9d67fa06ab398917660159654d514ec7e537f59bd7eeb485c21a6fbd0.jpg',
  },
  {
    title: '家属探视',
    desc: '当病患处于隔离或ICU病房等无菌环境时，远程探视体现人文关怀',
    pcUrl: MED_IMG_PRE_PATH + 'm/23bf3d1e11c4656da936312fb338657536faed650625b28e57f692ec410558d5.jpg',
  },
];
export const caseList = [
  [
    {
      logo: MED_IMG_PRE_PATH + 'e361496ec1c402a594fcb46f31ec0600907118c21b9a869aa109032d520eada5.jpg',
      title: '湖南省卫生健康委员会',
      desc: '湖南省卫健委携手小鱼易连，搭建覆盖全省的云视频远程会诊平台，建设了连接湖南全省20个贫困县的35家县级医院远程综合诊室、350个县级医院远程单科诊室和246个乡镇卫生院远程诊室。湖南省卫健委基于小鱼易连云视频“超高清、低延时、强互动”的高品质解决方案，组织张家界、常德、长沙、益阳、湘潭等多个地市的定点医院的医疗专家远程会诊患者，为疫情的远程诊疗、防疫防控建立“云防线”。',
      link: LINK_PRE_PATH + '1036',
    },
    {
      logo: MED_IMG_PRE_PATH + 'm/e065673e8b0bfcfa094dd4b2644c893a642bb0d4977b7d7b083d3945a0a94962.png',
      title: '南宁市卫生健康委员会',
      desc: '南宁卫健委成立防控总指挥部，基于小鱼易连整体解决方案，与辖区15家卫健局、13家市级医院、5家市级定点医院联动，并联网7家县级医院、121家乡镇卫生院，形成整套防疫体系。借助云视频打造的远程会诊应用，成为医疗机构和卫健部门间重要的沟通和交流方式，实现南宁市全部城区大型医院、区县医院、乡镇卫生所的覆盖，支持南宁市开展远程会诊、移动会诊、防疫防控等全场景应用。',
      link: LINK_PRE_PATH + '1036',
    },
    {
      logo: MED_IMG_PRE_PATH + 'm/de30febeccd4b32b13e3902ee9d0d85eea248bff36152d099f5b682ed08438c1.png',
      title: '遂宁市第一人民医院',
      desc: '遂宁市通过小鱼易连云视频构筑起“空中医院”疫情防控网，将市、区、县相对优质的医疗资源连接到了全市数百个行政村，患者无论身处何地，通过手机点击“空中医院”，就能接通高清视频向医生问诊，方便快捷。小鱼易连云视频覆盖了遂宁市卫生健康委、遂宁市第一人民医院、各区县卫健局以及遂宁市110个医疗机构发热门诊四级，真正实现了“让信息多跑路，让患者少跑腿”。',
      link: LINK_PRE_PATH + '920',
    },
    {
      logo: MED_IMG_PRE_PATH + 'm/8e33ace6b10495a2333b1b8cff2a4b720342cf5f44e205e9ba4ca18746ce4131.png',
      title: '西北妇女儿童医院',
      desc: '为加快推动妇幼健康服务体系建设，促进优质医疗资源下沉，西北妇女儿童医院携手小鱼易连，打造西北妇女儿童医院“云上妇幼”远程医疗平台。基于云视频在互联网下的互通互联能力，平台实现了对“省-市-县”三级妇幼保健机构的全覆盖，依托现有的危重孕产妇和新生儿救治网络以及妇幼保健体系，建立了完善“云上妇幼”工作机制，推动陕西省云上医疗服务可持续发展。',
      link: LINK_PRE_PATH + '069000',
    },
  ],
];
